// extracted by mini-css-extract-plugin
module.exports = {"cardText":"cardLoader_cardText___839E","manaCost":"cardLoader_manaCost__Y1lqD"};